var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import ReactDOM from 'react-dom';
import Store from './Store';
import { Wrapper } from '../components/wrapper';
import { resolvePosition } from '../utils/resolvePosition';
var StoreNotification = /** @class */ (function (_super) {
    __extends(StoreNotification, _super);
    function StoreNotification() {
        return _super.call(this) || this;
    }
    StoreNotification.prototype.render = function (position) {
        var positionClass = resolvePosition(position);
        var elm = document.querySelector(".wrapper-notifications.".concat(positionClass));
        var instances = this.getInstances(position);
        ReactDOM.render(React.createElement(Wrapper, { position: position, instances: instances, onRemove: this.unsubscribe }), elm
            ? elm.parentElement
            : document.body.appendChild(document.createElement('DIV')));
    };
    return StoreNotification;
}(Store));
export default StoreNotification;
